import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { User } from '@/services/user'
import { Logger } from '../services/logger'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/',
        name: 'LoginPage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/components/login/LoginForm.vue')
      },
      // TO: DO - to be changed to reset password
      {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('@/components/login/ResetPassword.vue')
      },
      {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/components/login/ForgotPassword.vue')
      }
    ]
  },
  {
    path: '/:id/details',
    name: 'DeviceDetail',
    component: () => import('@/views/DeviceDetail.vue'),
    meta: {
      requiresAuth: true,
      hideFeedbackButton: true
    }
  },
  {
    path: '/total-alerts',
    name: 'TotalAlerts',
    component: () => import('@/views/TotalAlerts.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/configurations',
    name: 'Configurations',
    component: () => import('@/views/Configurations.vue'),
    meta: {
      requiresAuth: true,
      permissionRoles: ['admin', 'user']
    }
  },
  {
    path: '/ai-configurations',
    name: 'AIConfigurations',
    component: () => import('@/views/AI-Configurations.vue'),
    meta: {
      requiresAuth: true,
      permissionRoles: ['admin', 'user']
    }
  },
  {
    path: '/performance',
    name: 'Performance',
    component: () => import('@/views/Performance.vue'),
    meta: {
      requiresAuth: true,
      permissionRoles: ['admin', 'user']
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: {
      requiresAuth: true,
      permissionRoles: ['admin']
    }
  },
  {
    path: '/deployedDeviceHistory',
    name: 'DeployedDeviceHistory',
    component: () => import('@/views/DeployedDeviceHistory.vue'),
    meta: {
      requiresAuth: true,
      permissionRoles: ['admin', 'user']
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/views/ChangePassword.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setLoader', true)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    verifyTokenAndRedirectPath(next, to)
    return
  }
  next()
})

router.afterEach((to) => {
  store.dispatch('setSingleProperty', ['hideFeedbackButton', to?.meta?.hideFeedbackButton])
  store.dispatch('setLoader', false)
})

const verifyTokenAndRedirectPath = async (next, to) => {
  try {
    const user = await User.verifyToken()
    if (user) {
      await store.dispatch('common/user/setUser', user)
      if (to.meta.permissionRoles && to.meta.permissionRoles.length && !User.hasPermission(to.meta.permissionRoles, user.roles)) {
        return next('/')
      }
      return next()
    } else {
      next('/login')
    }
  } catch (err) {
    next('/login')
    Logger.info(err.message)
  }
}

export default router
